import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import style from './action-button.module.less';
import { useModal } from '../../../../hooks/use-modal';
import { messages } from '../messages';
import { ExportModal } from '../modals/export/export-type-modal';

type ExportButtonProps = {
  disabled: boolean;
};

export const ExportButton = ({ disabled }: ExportButtonProps) => {
  const { isOpen, open, close } = useModal();

  return (
    <>
      <Button className={style['reusable-button']} disabled={disabled} onClick={open} theme={THEME_CONSTANTS.tertiary}>
        <FormattedMessage {...messages.exportButton} />
      </Button>
      {isOpen ? <ExportModal onCloseModal={close} /> : null}
    </>
  );
};
